import * as React from "react";
import Modal from "./Modal";
import Context from "./Context";
import ModalButton from "./ModalButton";
import ModalButtonList from "./ModalButtonList";
import ModalText from "./ModalText";

export default class ModalLogin extends React.Component<{
    type: number;
}> {

    public render(): React.ReactNode {
        return (
            <Context.Consumer>
                {({dispatch, translate}) => (
                    <Modal>
                        <ModalText>
                            {translate("MODAL_TEXT_LOGIN_" + this.props.type)}
                        </ModalText>
                        <ModalButtonList>
                            <ModalButton color="primary" onClick={() => {
                                dispatch("login/confirm");
                            }}>
                                {translate("MODAL_BUTTON_LOGIN")}
                            </ModalButton>
                            <ModalButton onClick={() => {
                                dispatch("login/cancel");
                            }}>
                                {translate("MODAL_BUTTON_CANCEL")}
                            </ModalButton>
                        </ModalButtonList>
                    </Modal>
                )}
            </Context.Consumer>
        );
    }

}